module.exports = __webpack_public_path__ + "static/media/07.cc85f57b.gif";